module.exports = __webpack_public_path__ + "img/02.461f2d66.jpg";